// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__253nr","header-navbar":"styles_header-navbar__LmFzq","header-logo":"styles_header-logo__1V6U8"};